<template>
	<div ref="item" class="group-member-bar" :class="active ? 'active' : ''" :style="{ 'min-height': height + 'px' }">
		<head-image :size="headImageSize" :name="member.showNickName" :url="member.headImage" :online="member.online"
			:isShowUserInfo="canViewProfile">
		</head-image>
		<div class="name">
			<div class="name-row">
				<div class="name-text" :title="member.showNickName">{{ member.showNickName }}</div>
			</div>
			<div v-if="mine.id == member.userId || member.userId == group.ownerId || member.isManager || member.isMuted" class="member-meta">
				<span v-if="mine.id == member.userId" class="member-pill member-pill--accent">我</span>
				<span v-if="member.userId == group.ownerId" class="member-pill member-pill--danger">群主</span>
				<span v-if="member.isManager" class="member-pill member-pill--accent">管理员</span>
				<span v-if="member.isMuted" class="member-pill member-pill--warning">禁言中</span>
			</div>
		</div>
		<slot></slot>
	</div>
</template>
<script>
import HeadImage from "../common/HeadImage.vue";

export default {
	name: "groupMemberBar",
	components: { HeadImage },
	data() {
		return {

		};
	},
	props: {
		group: {
			type: Object,
			required: true
		},
		member: {
			type: Object,
			required: true
		},
		height: {
			type: Number,
			default: 50
		},
		active: {
			type: Boolean,
			default: false
		},
		canViewProfile: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		headImageSize() {
			return Math.ceil(this.height * 0.75)
		}
	}
}
</script>


<style lang="scss" scoped>
.group-member-bar {
	display: flex;
	position: relative;
	padding: 0 12px;
	align-items: center;
	box-sizing: border-box;
	border-radius: 6px;
	margin: 0 1px;
	cursor: pointer;
	border: 1px solid transparent;
	transition: background-color 0.2s ease, border-color 0.2s ease;

	&:hover {
		background-color: var(--im-control-soft-bg-hover);
		border-color: rgba(var(--im-primary-rgb), 0.08);
	}

	&.active {
		background-color: rgba(var(--im-primary-rgb), 0.08);
		border-color: rgba(var(--im-primary-rgb), 0.16);
	}

	.name {
		display: flex;
		flex-direction: column;
		justify-content: center;
		flex: 1;
		height: 100%;
		padding: 8px 10px;
		padding-right: 8px;
		box-sizing: border-box;
		overflow: hidden;
		gap: 4px;

		.name-row {
			display: flex;
			align-items: center;
			flex-wrap: nowrap;
			gap: 4px;
			min-width: 0;
		}

		.name-text {
			text-align: left;
			font-size: 13px;
			font-weight: 500;
			line-height: 1.35;
			display: block;
			flex: 1 1 auto;
			max-width: 100%;
			overflow: hidden;
			min-width: 0;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		.member-meta {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			gap: 4px;
			min-width: 0;
		}

		.member-pill {
			display: inline-flex;
			align-items: center;
			height: 18px;
			padding: 0 5px;
			border-radius: 999px;
			font-size: 10px;
			line-height: 1;
			background: var(--im-control-tag-neutral-bg);
			color: var(--im-text-color-light);

			&.member-pill--accent {
				background: rgba(var(--im-primary-rgb), 0.08);
				color: var(--im-color-primary);
			}

			&.member-pill--danger {
				background: rgba(var(--im-danger-rgb), 0.1);
				color: var(--im-color-danger);
			}

			&.member-pill--warning {
				background: rgba(var(--im-warning-rgb), 0.12);
				color: var(--im-color-warning);
			}
		}
	}
}
</style>
